<script setup lang="ts">

import FaIcon from '@/application/components/ui/FaIcon.vue';
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElAlert } from 'element-plus';
import { Finanzmanager } from '@/application/router/types/types';
import { useRouter } from 'vue-router';
import AuthCardShell from '@/application/components/AuthCardShell.vue';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const router = useRouter();
const { duzen } = useBaseDataStore();

function getReason(): string {
 return router.options.history.state?.reason as string ??
   `${duzen('Du wurdest', 'Sie wurden')} erfolgreich abgemeldet.`;
}
</script>

<template>
  <AuthCardShell>
    <div class="text-center pb-5 text-blue-700">
      <FaIcon
        name="hand-wave"
        variant="light"
        size="3x"
        class="animate-handshake"
      />
    </div>
    <ElAlert
      type="success"
      class="w-full mb-7"
      title="Abgemeldet"
      show-icon
    >
      <div class="flex flex-col gap-2">
        <span
          class="text-base"
        >
          {{ getReason() }}
        </span>
      </div>
    </ElAlert>
    <RouterLink
      v-slot="{navigate}"
      :to="{ name: Finanzmanager.LOGIN }"
      custom
    >
      <AppButton
        class="w-full"
        type="primary"
        size="large"
        plain
        :handler="navigate"
      >
        zur Startseite
      </AppButton>
    </RouterLink>
  </AuthCardShell>
</template>
